var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbce200A498A754Bac596C92Ec061161B9C4A560(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2465 1933",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_2002_149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1232.5,
    cy: 966.5,
    rx: 548.5,
    ry: 282.5,
    fill: "var(--fill-0, #01C281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_149",
    x: 0,
    y: 0,
    width: 2465,
    height: 1933,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 342,
    result: "effect1_foregroundBlur_2002_149"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbce200A498A754Bac596C92Ec061161B9C4A560);
export default __webpack_public_path__ + "static/media/ebce200a498a754bac596c92ec061161b9c4a560.78777e324c78adeebd1ce33992892c29.svg";
export { ForwardRef as ReactComponent };